import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";
import ReactHelmet from "../../Components/ReactHelmet";
import { useLocation } from "react-router-dom";
import Styles from "./ZoomApp.module.css";

export default function ZoomDemoError() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const error = query.get("e");

  return (
    <>
      <ReactHelmet title={"Zoom Demo Class"} description={""} />
      <Navbar2 />
      <div
        className={Styles.Zoom_Container}
        style={{
          // margin: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {error ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div
              style={{
                border: "1px solid #ccc",
                padding: "20px",
                borderRadius: "8px",
                width: "350px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <h3 style={{ color: "red" }}>Something went wrong !</h3>
              <p>{error}</p>
            </div>

            <div style={{ marginTop: "20px" }}>
              <a
                href="/dashboard"
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  display: "inline-block",
                }}
              >
                Go to Dashboard
              </a>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div
              style={{
                border: "1px solid #ccc",
                padding: "20px",
                borderRadius: "8px",
                width: "300px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <h3 style={{ color: "black" }}>No Error found !</h3>
            </div>
            <div style={{ marginTop: "20px" }}>
              <a
                href="/dashboard"
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  display: "inline-block",
                }}
              >
                Go to Dashboard
              </a>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
